<app-mini-loader *ngIf="loading"></app-mini-loader>
<app-colapsable *ngIf="datoContratante && !loading" title="DATOS DEL RENTISTA" ($expandedChange)="expandChange()">
  <div description class="colapsable-panel-description non-mobile-only">
    <app-form-lablel [label]="'Nombre:'"></app-form-lablel>
    <app-form-text [text]="getFullName()"></app-form-text>
    <div class="spacer"></div>
    <app-form-lablel [label]="'Rut:'"></app-form-lablel>
    <app-form-text [text]="formatRUT(datoContratante?.Rut)"></app-form-text>
  </div>
  <div body [ngSwitch]="editMode">
    <app-error *ngIf="error"></app-error>
    <div *ngIf="!editMode">
      <div>
        <div class="container-rentista">
          <div class="rseparator margin-line"></div>
          <div class="rseparator2 margin-line"></div>
          <div class="rseparator3 margin-line"></div>
          <div class="resumen-grid-cell data-pair renta margin-grid">
            <span class="label">Renta mensual UF</span>
            <span class="value">{{
              resumen?.RentaMensual | number: '1.2-2'
            }}</span>
          </div>
          <div class="resumen-grid-cell data-pair ultimopago margin-grid">
            <span class="label">Último pago pensión</span>
            <span class="value">{{ resumen?.PeriodoUltimoPago | date }}</span>
          </div>

          <div class="resumen-grid-cell data-pair fechaprox margin-grid">
            <span class="label">Fecha próximo pago</span>
            <span class="value">{{ resumen?.FechaProximoPagoUI | date }}</span>
          </div>

          <div class="resumen-grid-cell data-pair invalidez margin-grid">
            <span class="label">Invalidez</span>
            <span class="value">{{ resumen?.Invalidez }}</span>
          </div>

          <div class="resumen-grid-cell data-pair formapago margin-grid">
            <span class="label">Forma de pago</span>
            <span class="value">{{ resumen?.FormaPago }}</span>
          </div>

          <div class="resumen-grid-cell data-pair banco margin-grid">
            <span class="label">Banco</span>
            <span class="value">{{ resumen?.Banco }}</span>
          </div>

          <div class="resumen-grid-cell data-pair cuenta margin-grid">
            <span class="label">Cuenta bancaria</span>
            <span class="value">{{ resumen?.CuentaBancaria || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="vseparator"></div>
      <div>
        <div class="vertical-flex">
          <div class="mobile-only responsive-row responsive-group">
            <div class="data-pair">
              <span class="label">Nombre:</span>
              <span class="uppercase value">{{ getFullName() }}</span>
            </div>
            <div class="data-pair">
              <span class="label">Rut:</span>
              <span class="uppercase value">{{
                formatRUT(datoContratante?.Rut)
              }}</span>
            </div>
          </div>
          <div class="responsive-row">
            <div class="data-pair">
              <span class="label">Teléfono particular</span>
              <span class="uppercase value"
                >+56 {{ datoContratante?.TelefonoCelular || '' }}</span
              >
            </div>
            <div class="data-pair">
              <span class="label">Teléfono comercial</span>
              <span class="uppercase value"
                >+56 {{ datoContratante?.TelefonoParticular || '' }}</span
              >
            </div>
            <div class="data-pair">
              <span class="label">Correo electrónico</span>
              <span class="uppercase value">{{
                datoContratante?.Mail || '-'
              }}</span>
            </div>
          </div>

          <div class="data-pair">
            <span class="label">Dirección Particular</span>
            <span
              class="uppercase value"
              *ngIf="datoContratante && datoContratante.Direccion"
            >
              {{ datoContratante?.Direccion }}, {{ datoContratante?.Comuna }},
              {{ datoContratante?.Ciudad }}
            </span>
          </div>
        </div>

        <div class="containerr-button" align="right">
          <button type="submit" (click)="onEditMode()" mat-flat-button>
            Modificar Datos
          </button>
        </div>
      </div>
    </div>
    <form [formGroup]="form" #registerForm="ngForm" (ngSubmit)="save()">
      <div *ngIf="editMode">
        <div>
          <div class="container-rentista">
            <div class="rseparator"></div>
            <div class="rseparator2"></div>
            <div class="rseparator3"></div>
            <div class="resumen-grid-cell data-pair renta margin-bottom-ie">
              <span class="label">Renta mensual UF</span>
              <span class="value">{{
                resumen?.RentaMensual | number: '1.2-2'
              }}</span>
            </div>

            <div
              class="resumen-grid-cell data-pair ultimopago margin-bottom-ie"
            >
              <span class="label">Último pago pensión</span>
              <span class="value">{{ resumen?.PeriodoUltimoPago | date }}</span>
            </div>

            <div class="resumen-grid-cell data-pair fechaprox margin-bottom-ie">
              <span class="label">Fecha próximo pago</span>
              <span class="value">{{
                resumen?.FechaProximoPagoUI | date
              }}</span>
            </div>

            <div class="resumen-grid-cell data-pair invalidez">
              <span class="label">Invalidez</span>
              <span class="value">{{ resumen?.Invalidez }}</span>
            </div>

            <div class="resumen-grid-cell data-pair formapago">
              <span class="label">Forma de pago</span>
              <span class="value">{{ resumen?.FormaPago }}</span>
            </div>

            <div class="resumen-grid-cell data-pair banco" style="width: 90%;">
              <div class="container-bank adjust-margin">
                <app-form-select
                  formControlName="BancoCodigo"
                  [label]="'Banco'"
                  [options]="bancos"
                  [optionValue]="'Codigo'"
                  [optionDescription]="'NombreBanco'"
                  [messageError]="getErrorMessage(form, 'BancoCodigo')"
                >
                </app-form-select>
                <a
                  *ngIf="ErrorBanco"
                  style="color: #f44336; font-size: 0.625rem; margin-top: -0.3125rem; height: 1.25rem;"
                  >Debe seleccionar banco.</a
                >
              </div>
            </div>

            <div class="resumen-grid-cell data-pair cuenta" style="width: 90%;">
              <div class="container-account-number">
                <app-form-input-text
                  (keyup)="ValidarNumCte($event)"
                  [label]="'Número de cuenta'"
                  [typeNumber]="true"
                  [maxlength]="15"
                  formControlName="NumeroCuenta"
                  [messageError]="getErrorMessage(form, 'NumeroCuenta')"
                ></app-form-input-text>
                <a
                  *ngIf="ErrorCuenta"
                  style="color: #f44336; font-size: 0.625rem; margin-top: -0.3125rem; height: 1.25rem;"
                  >Debe ingresar número de cuenta.</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="vseparator"></div>
        <div>
          <div class="vertical-flex">
            <div class="mobile-only responsive-row responsive-group">
              <div class="data-pair">
                <span class="label">Nombre:</span>
                <span class="uppercase value">{{ getFullName() }}</span>
              </div>
              <div class="data-pair">
                <span class="label">Rut:</span>
                <span class="uppercase value">{{
                  formatRUT(datoContratante?.Rut)
                }}</span>
              </div>
            </div>
            <div class="responsive-row">
              <div class="data-pair">
                <div class="container-phone adjust-margin">
                  <app-form-input-text
                    [prefix]="+56"
                    [maxlength]="9"
                    [label]="'Teléfono particular'"
                    formControlName="Telefono"
                    [messageError]="getErrorMessage(form, 'Telefono')"
                  ></app-form-input-text>
                </div>
              </div>
              <div class="data-pair">
                <div class="container-phone adjust-margin">
                  <app-form-input-text
                    [prefix]="+56"
                    [maxlength]="9"
                    [label]="'Teléfono celular'"
                    formControlName="celular"
                    [messageError]="getErrorMessage(form, 'celular')"
                  ></app-form-input-text>
                </div>
              </div>
              <div class="data-pair">
                <div class="container-email">
                  <app-form-input-text
                    [label]="'Correo electrónico'"
                    formControlName="Correo"
                    [messageError]="getErrorMessage(form, 'Correo')"
                  ></app-form-input-text>
                </div>
              </div>
            </div>

            <div class="data-pair">
              <span class="label">Dirección Particular</span>
              <span
                class="uppercase value"
                *ngIf="datoContratante && datoContratante.Direccion"
              >
                {{ datoContratante?.Direccion }}, {{ datoContratante?.Comuna }},
                {{ datoContratante?.Ciudad }}
              </span>
            </div>
          </div>
        </div>
        <div class="containerr-button" align="right">
          <button
            (click)="offEditMode()"
            mat-stroked-button
            class="button-detail"
          >
            Cancelar
          </button>
          <button
            type="submit"
            mat-flat-button
            [disabled]="!form.valid || !form.dirty"
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
    <div class="container-message">
      <svg-icon
        src="../../../assets/icons/exclamation-message.svg"
        [svgStyle]="{
          'width.rem': 1.5,
          'height.rem': 1.5,
          position: 'relative',
          'top.rem': 0.15
        }"
      ></svg-icon>

      <ul>
        <li>
          Las solicitudes de cambio de Modalidad de Pago de Pensión, ingresadas
          hasta el {{ this.FechaMensaje }} serán aplicadas al próximo pago de
          pensión. Las solicitudes de cambio ingresadas en fecha posterior,
          modificarán el subsiguiente pago.
        </li>
      </ul>
    </div>
  </div>
</app-colapsable>
